import React, {useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory, useLocation} from 'react-router-dom'
import {makeStyles} from '@material-ui/core'
import CardWithTitle from 'components/atoms/CardWithTitle'
import NoticeConfirmDialog from 'components/Dialog/NoticeConfirmDialog'
import PageTable from 'pages/Analysis/EEGSummary/PageTable'
import FiveIndicators from 'pages/Analysis/EEGSummary/Component/FiveIndicators'
import BrainFunctionConnectivity from 'pages/Analysis/EEGSummary/Component/BrainFunctionConnectivity'
import * as storage from 'api/storageApi'
import EEGSummaryReportStyle from 'pages/Analysis/EEGSummary/style'
import {
  EEG_SUMMARY_TABS,
  EEG_SUMMARY_TABS_HEALTH,
  TYPE_REPORT,
} from 'pages/Analysis/EEGSummary/constants'
import {isOrganizationHealth} from 'Authority'
import useProductManagement from 'features/productManagement/useProductManagement'
import {EEG_SUMMARY_ADVANCED_ID} from 'pages/ProductsPages/constant'

const useStyles = makeStyles(EEGSummaryReportStyle)
function EEGSummary() {
  const {t} = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const organizationType = storage.getOrganizationType()
  const isHealthOrg = isOrganizationHealth(organizationType)
  const [tabActive, setTabActive] = useState<number>(
    TYPE_REPORT.BRAIN_FUNCTION_MAPPING,
  )
  const {getAvailableLicenses, listAvailableLicenses} = useProductManagement()

  const listTabs = useMemo(() => {
    // if (isHealthOrg) return EEG_SUMMARY_TABS_HEALTH
    // return EEG_SUMMARY_TABS
    return EEG_SUMMARY_TABS
  }, [isHealthOrg])

  const isShowSummaryButton = useMemo(() => {
    return Array.from(
      new Set(listAvailableLicenses.map((license) => license.packageItemId)),
    ).some((packageId) => packageId === EEG_SUMMARY_ADVANCED_ID)
  }, [listAvailableLicenses])

  useEffect(() => {
    getAvailableLicenses()
  }, [])

  return (
    <>
      <CardWithTitle>
        <div className={`${classes.heathTabs}`}>
          {listTabs.map((item) => (
            <div
              className={`${classes.heathTab} ${
                tabActive === item.id && classes.heathTabActive
              }`}
              onClick={() => {
                setTabActive(item.id)
                history.replace({pathname: location.pathname})
              }}
              aria-hidden='true'
              key={item.id}
            >
              {t(item.label)}
            </div>
          ))}
        </div>

        {tabActive === TYPE_REPORT.BRAIN_FUNCTION_MAPPING && (
          <PageTable isShowSummaryButton={isShowSummaryButton} />
        )}
        {tabActive === TYPE_REPORT.FIVE_INDICATORS && (
          <FiveIndicators
            isActive={tabActive === TYPE_REPORT.FIVE_INDICATORS}
          />
        )}
        {tabActive === TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY && (
          <BrainFunctionConnectivity
            isActive={tabActive === TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY}
          />
        )}
      </CardWithTitle>
      <NoticeConfirmDialog />
    </>
  )
}

export default EEGSummary
